
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-env/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./blog-post.js") })
        }
      }, "page-component---src-templates-blog-post-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=page-component---src-templates-blog-post-js!./src/templates/blog-post.js
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=page-component---src-templates-blog-post-js!./src/templates/blog-post.js
// module chunks = 11